import React from "react";
import ReactPaginate from "react-paginate";

// react-paginate com as classes Bootstrap nativas (.pagination/.page-item/.page-link), tema via
// --bs-pagination-* em bootstrap-theme.css: "Mostrando x–y de N" à esquerda, páginas à direita.
// API externa (page 1-based) preservada pra não tocar nos lugares que já consomem PaginationBar.
export function PaginationBar({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const first = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(total, page * pageSize);

  return (
    <nav className="nt-pag" aria-label="Paginação">
      <span>
        Mostrando <span className="nt-mono">{first === last ? first : `${first}–${last}`}</span> de{" "}
        <span className="nt-mono">{total}</span>
      </span>
      <ReactPaginate
        previousLabel="‹"
        nextLabel="›"
        breakLabel="…"
        pageCount={totalPages}
        forcePage={page - 1}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={(sel) => onPageChange(sel.selected + 1)}
        containerClassName="pagination mb-0"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
        disabledClassName="disabled"
      />
    </nav>
  );
}
